import { addPartsCoe, allPartsCoe, deletePartsCoe, updatePartsCoe } from '@/utils/request'
import vue from '@/main'

const state = {
  partsCoeList: []
}

const mutations = {
  RESET (state) {
    state.partsCoeList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allPartsCoe().then(response => {
        state.partsCoeList = response.data
        resolve(state.partsCoeList)
      })
    })
  },
  partsCoeById ({ commit, state }, id) {
    for (const team of state.partsCoeList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, partsCoe) {
    return new Promise((resolve) => {
      updatePartsCoe(partsCoe).then(() => {
        for (const cur of state.partsCoeList) {
          if (cur.id === partsCoe.id) {
            Object.assign(cur, partsCoe)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addPartsCoe(team).then((response) => {
        state.partsCoeList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, partsCoe) {
    return new Promise((resolve) => {
      deletePartsCoe(partsCoe.id).then(() => {
        for (const i in state.partsCoeList) {
          if (state.partsCoeList[i].id === partsCoe.id) {
            state.partsCoeList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
